var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(`color: ${_vm.data.deadline[1]}`)},[_vm._v(_vm._s(_vm.data.deadline[0]))])
}
var staticRenderFns = []

export { render, staticRenderFns }